import * as React from 'react';
import { useResetPersistence } from '../hooks/useResetPersistence';
// TODO solve in a better way with more time

/**
 * Removes the data used to create and submit the order, that are no longer useful.
 */
export var ResetPersistence = function ResetPersistence() {
  var resetPersistence = useResetPersistence();
  React.useEffect(function () {
    resetPersistence();
  }, [resetPersistence]);
  return null;
};